import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=35f3d1ba&scoped=true"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"
import style0 from "./Servicio.vue?vue&type=style&index=0&id=35f3d1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3d1ba",
  null
  
)

export default component.exports